import { useNavigate } from "react-router-dom";
import { ComplaintModalLayout } from "./ComplaintModalLayout";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import { useComplaintDialog } from "./DialogContext";

ComplaintModalLayout.Footer = function Footer() {
  const { successView, accept, reject } = useComplaintDialog();
  const navigate = useNavigate();

  if (successView) {
    return (
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/complaint/all")}
        />
      </div>
    );
  }

  if (accept && reject) {
    return (
      <div className="mt-3 gap-2 flex-center-align">
        <GradientButton btnText="Complaint Resolved" onClick={accept} />
        <GrayButton btnText="Reject" onClick={reject} />
      </div>
    );
  }

  return null;
};
